import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

const SecureShieldIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M12,1 L14.519089,2.11959511 L21,5 L21,11 C21,16.55 17.16,21.74 12,23 C6.93381818,21.7629091 3.14007273,16.7374281 3.00379312,11.3023488 L3,11 L3,5 L12,1 Z M12,7 C10.9404545,7 10.0813636,7.82004132 10.0054536,8.85130541 L10,9 L10,10 L9.88380102,10.0067602 C9.42614796,10.0603316 9.06033163,10.426148 9.0067602,10.883801 L9,11 L9,14 L9.0067602,14.116199 C9.06033163,14.573852 9.42614796,14.9396684 9.88380102,14.9932398 L10,15 L14,15 L14.116199,14.9932398 C14.573852,14.9396684 14.9396684,14.573852 14.9932398,14.116199 L15,14 L15,11 L14.9932398,10.883801 C14.9396684,10.426148 14.573852,10.0603316 14.116199,10.0067602 L14,10 L14,9 L13.9944872,8.85006292 C13.9177686,7.81092975 13.05,7 12,7 Z M12,7.8 C12.61875,7.8 13.1320313,8.27460937 13.1937744,8.87775879 L13.2,9 L13.2,10 L10.8,10 L10.8,9 L10.8062256,8.87775879 C10.8679687,8.27460938 11.38125,7.8 12,7.8 Z" />
    </SvgIcon>
  );
};

export default SecureShieldIcon;
